export default __webpack_public_path__ + "static/media/Garrett.9ff14e74.jpg";